"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _Level = _interopRequireDefault(require("./Level"));
var _Condition = require("./Condition");
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validate = exports.validate = function validate(values) {
  var errors = {};
  function traverse(node, path) {
    if (node.conditions.length === 0) {
      errors[path] = 'At least one condition is required';
    }
    node.conditions.forEach(function (condition, index) {
      if (condition.conditions) {
        traverse(condition, "".concat(path, "[").concat(index, "].conditions"));
      } else if (!condition.column) {
        errors["".concat(path, "[").concat(index, "].column")] = 'Column is required';
      } else if (!condition.operator) {
        errors["".concat(path, "[").concat(index, "].operator")] = 'Operator is required';
      } else {
        var type = condition.column.type;
        var typeCondition = _Condition.allConditions[type].find(function (item) {
          return item.value === condition.operator;
        });
        if (typeCondition && typeCondition.validate) {
          (0, _mapValues2["default"])(typeCondition.validate(condition.value), function (value, key) {
            errors["".concat(path, "[").concat(index, "].").concat(key)] = value;
          });
        }
      }
    });
  }
  traverse(values, 'conditions');
  return errors;
};
var Component = function Component(props) {
  var updateFilter = props.updateFilter,
    closeModal = props.closeModal,
    initialValues = props.initialValues;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: _objectSpread({
      aggregation: 'all',
      conditions: [{
        id: 1,
        column: null,
        operator: ''
      }]
    }, initialValues),
    isInitialValid: false,
    validate: validate,
    onSubmit: function onSubmit(values) {
      updateFilter(values);
      closeModal();
    },
    render: function render(_ref) {
      var values = _ref.values;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_Level["default"], {
        path: "",
        values: values
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttons
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "submit",
        className: "btn btn-primary"
      }, "Save"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-warning",
        onClick: function onClick() {
          updateFilter(null);
          closeModal();
        }
      }, "Remove filter")));
    }
  }));
};
Component.propTypes = {
  updateFilter: _propTypes["default"].func,
  closeModal: _propTypes["default"].func,
  initialValues: _propTypes["default"].object
};
var _default = exports["default"] = Component;